import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { EdiDespatchAdvice } from '../../../models/edi';
import { EdiDispatchAdvicesActionConfigService } from '../../../services/edi-dispatch-advices-action-config/edi-dispatch-advices-action-config.service';
import { EdiDispatchAdviceDetailConfigService } from '../../../services/edi-dispatch-detail-config/edi-dispatch-detail-config.service';
import { EdiService } from '../../../services/edi/edi.service';
import { EdiNavigationService } from '../../../services/edi/edi-navigation.service';
import { EdiRowTable, EdiRowTableType } from '../edi-row-table/edi-row-table.component';
import { DateUtilService } from 'gung-common';
import { first } from 'rxjs';
import { BackendFeatureService } from '../../../services/backend-feature.service';
import { EDI_VIEWER_FEATURE_ID } from '../../../services/edi/edi-viewer-compatibility.service';

@Component({
  selector: 'lib-edi-dispatch-advice-detail',
  templateUrl: './edi-dispatch-advice-detail.component.html',
  styleUrls: ['./edi-dispatch-advice-detail.component.css'],
  standalone: false
})
export class EdiDispatchAdviceDetailComponent implements OnInit {
  protected route = inject(ActivatedRoute);
  protected router = inject(Router);
  protected ediService = inject(EdiService);
  public ediNavigationService = inject(EdiNavigationService);
  public configService = inject(EdiDispatchAdviceDetailConfigService);
  public actionConfig = inject(EdiDispatchAdvicesActionConfigService);
  protected translateService = inject(TranslateService);
  public dateUtilService = inject(DateUtilService);
  protected backendFeatureService = inject(BackendFeatureService);
  documentViewerEnabled$ = this.backendFeatureService.isActivated(EDI_VIEWER_FEATURE_ID);
  
  dispatchAdviceId: string;
  dispatchAdviceData: any;
  orderId: string;
  ediNavigationBaseRoute: string;

  showDispatchParcelManagement: boolean = false;

  itemsColumns: EdiRowTable[] = [
    {
      header: 'IMAGE',
      type: EdiRowTableType.IMAGE,
      getValue: (item: EdiDespatchAdvice) => item?.extra?.images
    },
    {
      header: 'ITEM_IDS',
      type: EdiRowTableType.TEXT,
      getValue: (item: EdiDespatchAdvice) => {
        let str = '';
        if (item.ids.gungId) {
          str += this.translateService.instant('ID', {}) + ': ' + item.ids.gungId;
        }
        if (item.ids.ean13) {
          if (!!str) {
            str += '\n';
          }
          str += this.translateService.instant('EAN', {}) + ': ' + item.ids.ean13;
        }
        if (item.ids.upca) {
          if (!!str) {
            str += '\n';
          }
          str += this.translateService.instant('UPCA', {}) + ': ' + item.ids.upca;
        }
        if (item.ids.buyerId) {
          if (!!str) {
            str += '\n';
          }
          str += this.translateService.instant('BUYER_ID', {}) + ': ' + item.ids.buyerId;
        }
        return str;
      },
      customClass: 'formatted'
    },
    {
      header: 'NAME',
      type: EdiRowTableType.TEXT,
      getValue: (item: EdiDespatchAdvice) => item.name
    },
    {
      header: 'PACKAGE_SSCC',
      type: EdiRowTableType.TEXT,
      getValue: (item: EdiDespatchAdvice) => {
        let str = '';
        for (const parcel of item.parcels) {
          if (!!str) {
            str += '\n';
          }
          str += parcel.ginIdentifier + ' : ' + this.translateService.instant('QTY', {}) + ' ' + parcel.quantity;
        }
        return str;
      },
      customClass: 'formatted'
    },
    {
      header: 'ORDER_NO',
      type: EdiRowTableType.TEXT,
      getValue: (item: EdiDespatchAdvice) => item.documentReferences?.buyerOrder?.id
    },
    {
      header: 'QUANTITY',
      type: EdiRowTableType.TEXT,
      getValue: (item: EdiDespatchAdvice) => item.quantities?.actualQuantity
    }
  ];


  ngOnInit(): void {
    this.route.params.subscribe(data => {
      this.dispatchAdviceId = data.id;

      const urlSegments = this.router.url.split('?')[0].split('/');
      this.ediNavigationBaseRoute = urlSegments.slice(0, -1).join('/');
      this.ediNavigationService.setNavigationCurrentId(this.ediNavigationBaseRoute, this.dispatchAdviceId);

      this.ediService.getDispatchAdvice(this.dispatchAdviceId).subscribe(dispatchAdviceData => {
        this.dispatchAdviceData = dispatchAdviceData.data;

        this.showDispatchParcelManagement = false;
        for (const error of this.dispatchAdviceData.errors) {
          if (error?.error?.includes('Despatch advice requires SSCC')) {
            this.showDispatchParcelManagement = true;
          }
        }
      });
    });
  }

  saveData(data: EdiDespatchAdvice): void {
    this.ediService.putDispatchAdvice(data.id, data).pipe(first()).subscribe(res => {
      this.dispatchAdviceData = res.data;
    });
  }
}
